import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConfirmInfoIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 64 64"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#EFF8FF" height="64" rx="32" width="64" />
    <rect fill="#D1E9FF" height="48" rx="24" width="48" x="8" y="8" />
    <g clipPath="url(#clip0_4718_45121)">
      <rect fill="#1570EF" height="32" rx="16" width="32" x="16" y="16" />
      <circle cx="32" cy="32" fill="white" r="9" />
      <path
        clipRule="evenodd"
        d="M32 18.6667C24.6362 18.6667 18.6666 24.6362 18.6666 32C18.6666 39.3638 24.6362 45.3334 32 45.3334C39.3638 45.3334 45.3333 39.3638 45.3333 32C45.3333 24.6362 39.3638 18.6667 32 18.6667ZM33.3333 26.6667C33.3333 25.9303 32.7363 25.3334 32 25.3334C31.2636 25.3334 30.6666 25.9303 30.6666 26.6667V26.6968C30.6666 27.4332 31.2636 28.0302 32 28.0302C32.7363 28.0302 33.3333 27.4332 33.3333 26.6968V26.6667ZM31.3333 30C30.5969 30 30 30.597 30 31.3334C30 31.8269 30.2681 32.2578 30.6666 32.4883V36C29.9302 36 29.3333 36.597 29.3333 37.3334C29.3333 38.0697 29.9302 38.6667 30.6666 38.6667H33.3333C34.0697 38.6667 34.6666 38.0697 34.6666 37.3334C34.6666 36.597 34.0697 36 33.3333 36V32C33.3333 30.8955 32.4379 30 31.3333 30Z"
        fill="#1570EF"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4718_45121">
        <rect fill="white" height="32" rx="16" width="32" x="16" y="16" />
      </clipPath>
    </defs>
  </svg>
);

ConfirmInfoIcon.propTypes = {
  ...sizePropsTypes,
};

export default ConfirmInfoIcon;
